<template>
  <v-container grid-list-lg px-5>
    <v-layout wrap justify-center align-center pl-5 pr-1>
      <v-flex xs12 md8 lg6>
        <v-layout wrap>
          <v-flex v-for="(item, index) in items" :key="index" xs12 d-flex child-flex>
            <v-layout column fluid mb-5>
            <p class="title" style="margin-bottom: 0px">{{treatName(item.name)}}</p>
            <v-card hover class="d-flex">
              <video width="100%" height="100%" controls>
                <source :src="item.url[0]" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            </v-card>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db } from '@/firebase/db';

export default {
  methods: {
    treatName(name) {
      return name.split('.')[0];
    },
  },
  mounted() {
    this.$bind('videoChapter', db.collection('videos').doc(this.$route.params.videoChapterID));
    this.$bind(
      'items',
      db
        .collection('videos')
        .doc(this.$route.params.videoChapterID)
        .collection('files')
        .orderBy('name'),
    );
  },
  watch: {
    videoChapter: {
      handler(newVideoChapter) {
        this.$store.state.currentVideoChapter = newVideoChapter.name;
      },
    },
  },
  data: () => ({
    imageDialog: false,
    items: [],
    videoChapter: null,
    carouselIndex: 0,
    continuousCarousel: false,
  }),
};
</script>
